import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "5.5",
    width: "28",
    height: "4.2",
    rx: "2.1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "13.90002",
    width: "28",
    height: "4.2",
    rx: "2.1",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "22.3",
    width: "28",
    height: "4.2",
    rx: "2.1",
    fill: "currentColor"
  })
], -1 /* HOISTED */)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("TODO normalized SVG"),
    _hoisted_1
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
export default { render: render }